import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratoryDepartments: ILaboratoryDepartmentsLoadActionCreator = () => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_LOAD
        }
    },
    LoadLaboratoryDepartmentById: ILaboratoryDepartmentLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID,
            id
        }
    },
    LoadLaboratoryDepartmentsByLaboratoryId: ILaboratoryDepartmentsLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID,
            laboratoryId
        }
    },
    LoadSuccess: ILaboratoryDepartmentLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryDepartmentLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratoryDepartment: ILaboratoryDepartmentSaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratoryDepartmentSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratoryDepartmentSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratoryDepartment: ILaboratoryDepartmentCreateActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYDEPARTMENT_CREATE,
            laboratoryId
        }
    },
    CreateSuccess: ILaboratoryDepartmentCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryDepartmentCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteLaboratoryDepartment: ILaboratoryDepartmentDeleteActionCreator = (laboratoryDepartmentId) => {

        return {
            type: ACTION_LABORATORYDEPARTMENT_DELETE,
            laboratoryDepartmentId
        }
    },
    DeleteSuccess: ILaboratoryDepartmentDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_DELETE_SUCCESS
        }
    },
    DeleteFailure: ILaboratoryDepartmentDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_DELETE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratoryDepartment: ILaboratoryDepartmentValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryDepartmentValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryDepartmentValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryDepartmentClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryDepartmentFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORYDEPARTMENT_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORYDEPARTMENT_LOAD = "ACTION_LABORATORYDEPARTMENT_LOAD",
    ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID = "ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID",
    ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID = "ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID",
    ACTION_LABORATORYDEPARTMENT_LOAD_SUCCESS = "ACTION_LABORATORYDEPARTMENT_LOAD_SUCCESS",
    ACTION_LABORATORYDEPARTMENT_LOAD_FAILURE = "ACTION_LABORATORYDEPARTMENT_LOAD_FAILURE",

    ACTION_LABORATORYDEPARTMENT_SAVE = "ACTION_LABORATORYDEPARTMENT_SAVE",
    ACTION_LABORATORYDEPARTMENT_SAVE_SUCCESS = "ACTION_LABORATORYDEPARTMENT_SAVE_SUCCESS",
    ACTION_LABORATORYDEPARTMENT_SAVE_FAILURE = "ACTION_LABORATORYDEPARTMENT_SAVE_FAILURE",

    ACTION_LABORATORYDEPARTMENT_CREATE = "ACTION_LABORATORYDEPARTMENT_CREATE",
    ACTION_LABORATORYDEPARTMENT_CREATE_SUCCESS = "ACTION_LABORATORYDEPARTMENT_CREATE_SUCCESS",
    ACTION_LABORATORYDEPARTMENT_CREATE_FAILURE = "ACTION_LABORATORYDEPARTMENT_CREATE_FAILURE",

    ACTION_LABORATORYDEPARTMENT_DELETE = "ACTION_LABORATORYDEPARTMENT_DELETE",
    ACTION_LABORATORYDEPARTMENT_DELETE_SUCCESS = "ACTION_LABORATORYDEPARTMENT_DELETE_SUCCESS",
    ACTION_LABORATORYDEPARTMENT_DELETE_FAILURE = "ACTION_LABORATORYDEPARTMENT_DELETE_FAILURE",

    ACTION_LABORATORYDEPARTMENT_VALIDATE = "ACTION_LABORATORYDEPARTMENT_VALIDATE",
    ACTION_LABORATORYDEPARTMENT_VALIDATE_SUCCESS = "ACTION_LABORATORYDEPARTMENT_VALIDATE_SUCCESS",
    ACTION_LABORATORYDEPARTMENT_VALIDATE_FAILURE = "ACTION_LABORATORYDEPARTMENT_VALIDATE_FAILURE",

    ACTION_LABORATORYDEPARTMENT_CLEAR = "ACTION_LABORATORYDEPARTMENT_CLEAR",

    ACTION_LABORATORYDEPARTMENT_FILTER = "ACTION_LABORATORYDEPARTMENT_FILTER";

export interface ILaboratoryDepartmentsLoadAction {
    type: "ACTION_LABORATORYDEPARTMENT_LOAD";
}

export interface ILaboratoryDepartmentsLoadActionCreator {
    (): ILaboratoryDepartmentsLoadAction;
}

export interface ILaboratoryDepartmentLoadSuccessAction {
    type: "ACTION_LABORATORYDEPARTMENT_LOAD_SUCCESS";
    formData: Dtos.LaboratoryDepartment | Dtos.LaboratoryDepartment[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryDepartmentLoadSuccessActionCreator {
    (
        formData: Dtos.LaboratoryDepartment | Dtos.LaboratoryDepartment[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryDepartmentLoadSuccessAction;
}

export interface ILaboratoryDepartmentLoadFailureAction {
    type: "ACTION_LABORATORYDEPARTMENT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryDepartmentLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryDepartmentLoadFailureAction;
}

export interface ILaboratoryDepartmentLoadByIdAction {
    type: "ACTION_LABORATORYDEPARTMENT_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryDepartmentLoadByIdActionCreator {
    (id: number): ILaboratoryDepartmentLoadByIdAction;
}

export interface ILaboratoryDepartmentsLoadByLaboratoryIdAction {
    type: "ACTION_LABORATORYDEPARTMENTS_LOAD_BY_LABORATORYID";
    laboratoryId: number;
}

export interface ILaboratoryDepartmentsLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ILaboratoryDepartmentsLoadByLaboratoryIdAction;
}


export interface ILaboratoryDepartmentSaveAction {
    type: "ACTION_LABORATORYDEPARTMENT_SAVE";
    formData: Dtos.LaboratoryDepartment;

}

export interface ILaboratoryDepartmentSaveActionCreator {
    (
        formData: Dtos.LaboratoryDepartment
    ): ILaboratoryDepartmentSaveAction;
}

export interface ILaboratoryDepartmentSaveSuccessAction {
    type: "ACTION_LABORATORYDEPARTMENT_SAVE_SUCCESS";
    formData: Dtos.LaboratoryDepartment;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryDepartmentSaveSuccessActionCreator {
    (
        formData: Dtos.LaboratoryDepartment,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryDepartmentSaveSuccessAction;
}

export interface ILaboratoryDepartmentSaveFailureAction {
    type: "ACTION_LABORATORYDEPARTMENT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryDepartmentSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryDepartmentSaveFailureAction;
}

export interface ILaboratoryDepartmentCreateAction {
    type: "ACTION_LABORATORYDEPARTMENT_CREATE";
    laboratoryId: number;
}

export interface ILaboratoryDepartmentCreateActionCreator {
    (laboratoryId: number): ILaboratoryDepartmentCreateAction
}

export interface ILaboratoryDepartmentCreateSuccessAction {
    type: "ACTION_LABORATORYDEPARTMENT_CREATE_SUCCESS";
    formData: Dtos.LaboratoryDepartment;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ILaboratoryDepartmentCreateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryDepartment,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryDepartmentCreateSuccessAction;
}

export interface ILaboratoryDepartmentCreateFailureAction {
    type: "ACTION_LABORATORYDEPARTMENT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryDepartmentCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryDepartmentCreateFailureAction;
}

export interface ILaboratoryDepartmentDeleteAction {
    type: "ACTION_LABORATORYDEPARTMENT_DELETE";
    laboratoryDepartmentId: number;
}

export interface ILaboratoryDepartmentDeleteActionCreator {
    (laboratoryDepartmentId: number): ILaboratoryDepartmentDeleteAction
}

export interface ILaboratoryDepartmentDeleteSuccessAction {
    type: "ACTION_LABORATORYDEPARTMENT_DELETE_SUCCESS";
}

export interface ILaboratoryDepartmentDeleteSuccessActionCreator {
    (): ILaboratoryDepartmentDeleteSuccessAction;
}

export interface ILaboratoryDepartmentDeleteFailureAction {
    type: "ACTION_LABORATORYDEPARTMENT_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryDepartmentDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryDepartmentDeleteFailureAction;
}

export interface ILaboratoryDepartmentValidateAction {
    type: "ACTION_LABORATORYDEPARTMENT_VALIDATE";
    formData: Dtos.LaboratoryDepartment;

}

export interface ILaboratoryDepartmentValidateActionCreator {
    (
        formData: Dtos.LaboratoryDepartment
    ): ILaboratoryDepartmentValidateAction;
}

export interface ILaboratoryDepartmentValidateSuccessAction {
    type: "ACTION_LABORATORYDEPARTMENT_VALIDATE_SUCCESS";
    formData: Dtos.LaboratoryDepartment;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryDepartmentValidateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryDepartment,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryDepartmentValidateSuccessAction;
}

export interface ILaboratoryDepartmentValidateFailureAction {
    type: "ACTION_LABORATORYDEPARTMENT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryDepartmentValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryDepartmentValidateFailureAction;
}

export interface ILaboratoryDepartmentClearAction {
    type: "ACTION_LABORATORYDEPARTMENT_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryDepartmentClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryDepartmentClearAction;
}

export interface ILaboratoryDepartmentFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryDepartmentFilterAction;
}

export interface ILaboratoryDepartmentFilterAction {
    type: "ACTION_LABORATORYDEPARTMENT_FILTER";
    formFilter: IFormFilter;
}

export type LaboratoryDepartmentAction =
    ILaboratoryDepartmentsLoadAction |
    ILaboratoryDepartmentLoadByIdAction |
    ILaboratoryDepartmentsLoadByLaboratoryIdAction |
    ILaboratoryDepartmentLoadFailureAction |
    ILaboratoryDepartmentLoadSuccessAction |
    ILaboratoryDepartmentSaveAction |
    ILaboratoryDepartmentSaveSuccessAction |
    ILaboratoryDepartmentSaveFailureAction |
    ILaboratoryDepartmentCreateAction |
    ILaboratoryDepartmentCreateSuccessAction |
    ILaboratoryDepartmentCreateFailureAction |
    ILaboratoryDepartmentDeleteAction |
    ILaboratoryDepartmentDeleteSuccessAction |
    ILaboratoryDepartmentDeleteFailureAction |
    ILaboratoryDepartmentValidateAction |
    ILaboratoryDepartmentValidateSuccessAction |
    ILaboratoryDepartmentValidateFailureAction |
    ILaboratoryDepartmentClearAction |
    ILaboratoryDepartmentFilterAction;
